import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const metaConfig = {
  '/': {
    title: 'J F D Service | Udlejning af festtelte, maskiner og festudstyr',
    description: 'Lej festtelte, slushice-maskiner, popcornmaskiner, Soundbox, hoppeborge og entreprenørmaskiner hos J F D Service. Vi leverer og opsætter til din næste fest!'
  },
  '/udlejning': {
    title: 'Udlejning af festudstyr & maskiner | J F D Service',
    description: 'Se vores store udvalg af festudstyr til udlejning. Vi tilbyder slushice-maskiner, popcornmaskiner, Soundbox 3, hoppeborge, pølsevogne, køleskabe og meget mere.'
  },
  '/udlejning/slushice-maskine': {
    title: 'Lej Slushice Maskine | Festlig afkøling til gæsterne | J F D Service',
    description: 'Lej en professionel slushice-maskine til din fest. Nem betjening, lækre smagsvarianter og garanteret succes hos både børn og voksne.'
  },
  '/udlejning/popcorn-maskine': {
    title: 'Lej Popcornmaskine | Duften af nylavede popcorn | J F D Service',
    description: 'Lej en professionel popcornmaskine til din næste fest eller event. Vi leverer alt det nødvendige tilbehør som majs, salt og kræmmerhuse.'
  },
  '/udlejning/soundbox-3': {
    title: 'Lej Soundboks 3 | Ultimativ lyd og bas til festen | J F D Service',
    description: 'Lej en Soundboks 3 med ekstrem lydstyrke og lang batterilevetid. Perfekt til havefester, fødselsdage og events. Nem tilslutning med Bluetooth.'
  },
  '/udlejning/hoppeborg': {
    title: 'Lej Hoppeborg | Sjov og aktivitet for børnene | J F D Service',
    description: 'Gør børnefødselsdagen eller havefesten uforglemmelig med en stor, sikker og godkendt hoppeborg. Vi tilbyder nem leje og hurtig opsætning.'
  },
  '/udlejning/poelsevogn': {
    title: 'Lej Pølsevogn | Den ultimative natmad til festen | J F D Service',
    description: 'Lej en komplet pølsevogn til din fest eller event. Perfekt til natmad eller uformel servering. Vi tilbyder udlejning med alt det nødvendige udstyr.'
  },
  '/udlejning/glas': {
    title: 'Lej Glas til Festen | Flotte glas til alle drikkevarer | J F D Service',
    description: 'Udlejning af flotte og rene glas til øl, vin, drinks og sodavand. Slip for opvasken og lej dine glas billigt hos J F D Service.'
  },
  '/udlejning/sugeroer-med-ske': {
    title: 'Tilbehør til Slushice | Sugerør med ske & kopper | J F D Service',
    description: 'Køb sugerør med ske og plastikkopper til din lejede slushice-maskine. Vi har alt det nødvendige tilbehør til den perfekte slushice-oplevelse.'
  },
  '/udlejning/koeleskab-med-glaslaage': {
    title: 'Lej Flaskekøleskab med Glaslåge | Kolde drikkevarer | J F D Service',
    description: 'Lej et professionelt flaskekøleskab med glaslåge og lys. Perfekt til at holde øl, sodavand og hvidvin kolde og præsentable til festen.'
  },
  '/udlejning/almindeligt-koeleskab': {
    title: 'Lej Almindeligt Køleskab | Ekstra køleplads til festen | J F D Service',
    description: 'Mangler du køleplads til mad og drikke til din fest? Lej et ekstra, pålideligt køleskab hos J F D Service til en skarp pris.'
  },
  '/udlejning/lille-fryser': {
    title: 'Lej Lille Fryser | Perfekt til isterninger og frostvarer | J F D Service',
    description: 'Lej en lille, praktisk fryser til opbevaring af isterninger, isvafler eller frostvarer til din fest eller event.'
  },
  '/udlejning/varmeovn-gas': {
    title: 'Lej Gasvarmeovn | Effektiv opvarmning af festteltet | J F D Service',
    description: 'Hold varmen i festteltet eller udestuen med en effektiv gasvarmeovn. Sikker og nem at betjene med hurtig varmeafgivelse.'
  },
  '/udlejning/varmekanon-gas': {
    title: 'Lej Gasvarmekanon | Kraftfuld opvarmning af store telte | J F D Service',
    description: 'Lej en kraftfuld gasvarmekanon til hurtig og effektiv opvarmning af store festtelte, haller eller garager. Perfekt til kolde dage.'
  },
  '/telt-udlejning': {
    title: 'Teltudlejning | Lej festtelte i høj kvalitet | J F D Service',
    description: 'Professionel teltudlejning til bryllup, konfirmation, havefest og firmafest. Vi tilbyder stabile festtelte i mange størrelser inkl. levering og opsætning.'
  },
  '/telt-udlejning/firkantet-bord': {
    title: 'Lej Firkantede Borde | Fleksibel bordopstilling | J F D Service',
    description: 'Lej robuste, firkantede borde til din fest. Perfekt til traditionelle langborde eller fleksible bordopstillinger i festteltet.'
  },
  '/telt-udlejning/runde-bord': {
    title: 'Lej Runde Borde | Skab en hyggelig og intim stemning | J F D Service',
    description: 'Lej smukke, runde borde til bryllup, konfirmation eller gallafest. Runde borde fremmer samtalen og giver et elegant udtryk.'
  },
  '/telt-udlejning/stole': {
    title: 'Lej Stole til Festen | Behagelige og pæne feststole | J F D Service',
    description: 'Udlejning af pæne og komfortable stole til din fest. Vores stole er nemme at stable og passer perfekt ind i ethvert festtelt.'
  },
  '/telt-udlejning/gulv': {
    title: 'Lej Plastikgulv til Festtelt | Stabilt og tørt underlag | J F D Service',
    description: 'Lej professionelt plastikgulv til dit festtelt. Sikrer et stabilt, tørt og jævnt underlag til borde, stole og dansesko.'
  },
  '/telt-udlejning/lysk-der': {
    title: 'Lej Lyskæder | Hyggelig belysning til festteltet | J F D Service',
    description: 'Skab den perfekte stemning i festteltet eller haven med vores flotte lyskæder. Nemme at hænge op og giver et varmt, indbydende lys.'
  },
  '/telt-udlejning/cafebord': {
    title: 'Lej Cafeborde / Ståborde | Perfekt til reception og velkomstdrink | J F D Service',
    description: 'Lej høje cafeborde/ståborde til din reception, havefest eller velkomstdrink. Praktiske, elegante og fylder minimalt.'
  },
  '/maskiner': {
    title: 'Maskinudlejning | Lej minigraver, motorbør og entreprenørmaskiner | J F D Service',
    description: 'Professionel maskinudlejning til private og erhverv. Lej minigraver, motorbør, flishugger og andet entreprenørmateriel til skarpe priser.'
  },
  '/priser': {
    title: 'Prisliste | Se priser på teltudlejning og festudstyr | J F D Service',
    description: 'Få et fuldt overblik over vores priser på udlejning af festtelte, borde, stole, slushice-maskiner, popcornmaskiner, hoppeborge og maskiner.'
  },
  '/om-os': {
    title: 'Om J F D Service | Din pålidelige partner til fest og maskiner',
    description: 'Læs mere om J F D Service. Vi leverer professionel service, høj kvalitet og pålidelig udlejning af festudstyr, telte og entreprenørmaskiner.'
  },
  '/lejebetingelser': {
    title: 'Lejebetingelser & Handelsbetingelser | J F D Service',
    description: 'Læs vores lejebetingelser for leje af telte, festudstyr og maskiner. Her finder du information om levering, ansvar, rengøring og afbestilling.'
  },
  '/kontakt': {
    title: 'Kontakt Os | Book festudstyr, telte eller maskiner | J F D Service',
    description: 'Kontakt J F D Service for booking eller spørgsmål. Ring til os på 22 42 60 11, send en e-mail eller udfyld vores kontaktformular.'
  },
  '/403': {
    title: 'Ingen adgang (403) | J F D Service',
    description: 'Du har ikke adgang til denne side.'
  },
  '/404': {
    title: 'Siden blev ikke fundet (404) | J F D Service',
    description: 'Den søgte side findes desværre ikke.'
  }
};

export default function MetaManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Skip dynamic machine details route as it handles its own metadata
    if (path.startsWith('/maskiner/')) {
      return;
    }

    const meta = metaConfig[path] || {
      title: 'J F D Service | Udlejning af festtelte, maskiner og festudstyr',
      description: 'Lej festtelte, slushice-maskiner, popcornmaskiner, Soundbox, hoppeborge og entreprenørmaskiner hos J F D Service. Vi leverer og opsætter til din næste fest!'
    };

    document.title = meta.title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', meta.description);
  }, [location]);

  return null;
}
